// extracted by mini-css-extract-plugin
export default {"root":"TtYZig","header":"fmxtbg","contentWrapper":"cdhWLu","tabs":"banaTY"};